// extracted by mini-css-extract-plugin
module.exports = {"caption":"styles_caption__2CxJO","caption_text":"styles_caption_text__3meBf"};